import { InputHTMLAttributes, TextareaHTMLAttributes, forwardRef } from "react";
import { Input } from "../shad/input";
import { textVariants } from "../Text/Text";
import { cn } from "@/lib/utils";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  errors?: string;
}
const InputComponent = forwardRef<HTMLInputElement, Props>(
  ({ label, errors, className, ...props }, ref) => {
    return (
      <div className="grid w-full gap-1">
        <label
          className={textVariants({
            size: "sm",
            font: "semibold",
            variant: "desc",
          })}
        >
          {label}
        </label>
        <Input
          ref={ref}
          {...props}
          className={cn(
            "focus:outline-indigo-400 dark:focus:outline-grey-400 focus:outline-none dark:bg-grey-600 bg-input-field  dark:text-white dark:placeholder:text-gray-200",
            className
          )}
        />
        {errors && (
          <span className="text-red-500 text-xs font-medium">{errors}</span>
        )}
      </div>
    );
  }
);

export default InputComponent;

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  errors?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, label, errors, ...props }, ref) => {
    return (
      <div className="grid w-full gap-1">
        <label className={"text-sm font-semibold text-gray-600"}>{label}</label>
        <textarea
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
        {errors && (
          <span className="text-red-500 text-xs font-medium">{errors}</span>
        )}
      </div>
    );
  }
);

TextArea.displayName = "TextArea";

// "text-sm font-semibold text-gray-800 "
